import React__default, { useState } from 'react';
import { FlexBox, AlertBox, AlertBoxDismissButton, Typography, Spinner } from '@vp/swan';
import { QtyStartingAtPrice } from '@vp/vp-tokenized-fragment';
import { useConfiguratorContext } from '../contexts/configuratorContext/useConfiguratorContext.mjs';
import { useWranglerDataContext } from '@vp/wrangler-data-source';
import '../contexts/configuratorContext/configuratorContext.mjs';

const FooterPrice = () => {
    const { onPriceUpdated, selectedQuantity, priceInfo, uiLabels, isLoading } = useConfiguratorContext();
    const { data } = useWranglerDataContext();
    const [priceProps, setPriceProps] = useState(undefined);
    const [showLoadingError, setShowLoadingError] = useState(false);
    React__default.useEffect(() => {
        if (priceInfo) {
            onPriceUpdated?.(priceInfo);
            setPriceProps(priceInfo.quantities?.find((p) => p.quantity === selectedQuantity));
        }
        else {
            setPriceProps(undefined);
        }
    }, [priceInfo]);
    React__default.useEffect(() => {
        if (Object.keys(data?.price || {}).length === 0 && isLoading === false) {
            setShowLoadingError(true);
        }
        else {
            setShowLoadingError(false);
        }
    }, [data?.price, isLoading]);
    return (React__default.createElement(FlexBox, { alignItems: "center", flexDirection: "row", justifyContent: "space-between", style: { height: showLoadingError ? undefined : "50px", width: "100%" } }, showLoadingError
        ? React__default.createElement(AlertBox, { mb: "4", skin: "error" },
            uiLabels.loadingError,
            React__default.createElement(AlertBoxDismissButton, { accessibleText: uiLabels.close }))
        : React__default.createElement(Typography, null, priceProps
            ? React__default.createElement("output", null,
                React__default.createElement(QtyStartingAtPrice, { placeHolderText: "...", pricingInfo: priceProps }))
            : React__default.createElement(Spinner, { accessibleText: "...", layout: "horizontal" }))));
};

export { FooterPrice };
//# sourceMappingURL=FooterPrice.mjs.map
